import React, { useEffect, useRef, useState } from 'react';
import './videos.css';
import { thumbnailTool, videoSourceFinder, videoTitleTool } from './utils';

const SingleVideoPage = ({ pathName }) => {
  const videoTitle = videoTitleTool(pathName);
  const thumbnail = thumbnailTool(pathName);
  const videoSrc = videoSourceFinder(pathName);
  return (
    <div className="black-container">
      <div className="middle-container">
        <div className="video-text">{videoTitle}</div>
        <div className="big-video-container">
          <video
            controls
            className="big-video-frame"
            poster={thumbnail}
            controlsList="nodownload"
            onContextMenu={e => e.preventDefault()}>
            <source src={videoSrc} type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  );
};

export default SingleVideoPage;



// WEBPACK FOOTER //
// ./src/components/Videos/SingleVideoPage.js